import { render, staticRenderFns } from "./PsPatientsListItem.vue?vue&type=template&id=c5703276&scoped=true&"
import script from "./PsPatientsListItem.vue?vue&type=script&lang=js&"
export * from "./PsPatientsListItem.vue?vue&type=script&lang=js&"
import style0 from "./PsPatientsListItem.vue?vue&type=style&index=0&id=c5703276&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5703276",
  null
  
)

export default component.exports